import { createSelector } from 'reselect'
import getLocationRouterSelect from 'modules/router/selectors/get-location/index.js'

const isReplacingExerciseRouterSelect = createSelector(
  getLocationRouterSelect,
  location => {
    const locationState = location?.state
    return !!locationState?.replacingWorkoutExerciseId
  }
)

export default isReplacingExerciseRouterSelect
